import { API, fetcher } from "@/shared/core-configs";
import { Product } from "@/shared/core-products";

export interface ReplenishmentScanResponse {
  invoiceNumber: string;
  invoiceRut: string;
  products: {
    product: Product;
    quantity: number;
    price: number;
  }[];
}

export const replenishmentApi = {
  scan: async (file: File): Promise<ReplenishmentScanResponse> => {
    const formData = new FormData();
    formData.append("invoiceFile", file);
    const res = await fetcher.post(
      `${API.GESLUB_SERVICE}/repositions/scan`,
      formData,
    );
    return res.data;
  },
  uploadInvoice: async (id: string, file: File): Promise<void> => {
    const formData = new FormData();
    formData.append("invoiceFile", file);
    await fetcher.post(
      `${API.GESLUB_SERVICE}/repositions/${id}/invoice`,
      formData,
    );
  },
  exportRepositionsExcel: async (params: string) => {
    const response = await fetcher.get(
      `${API.GESLUB_SERVICE}/repositions/export-excel?${params}`,
      { responseType: "blob" },
    );
    if (!response) {
      throw new Error("Error al exportar reposiciones a Excel");
    }
    return response.data;
  },
};
